import React from 'react';
import GlobalContext from '../GlobalContext';
import QuoteRequestForm, { BrochureBtn } from '../BFComponents';

const PDHeader = (props) => {
    const paths = GlobalContext().paths;

    let divSpecCol1 = props.item.HeaderLayoutFlag === 1 ? "col-md-8" : "col-md-6";
    divSpecCol1 += " d-flex flex-column";
    let divSpecCol2 = props.item.HeaderLayoutFlag === 1 ? "col-md-4" : "col-md-6";
    divSpecCol2 += " d-flex flex-column align-items-center justify-content-center text-center";
    const points = props.item.FourPoints;
    const render_color = { backgroundColor: "#" + props.item.RenderColor1 };
    return (
        <div className="row">
            <div className={divSpecCol1}>
                <div className="d-flex">
                    <img height="50px" src={paths.pictures + "canon-logo.jpg"}></img>
                </div>
                <h3 id="productName">{props.item.ProductName}</h3>
                {props.item.ProductTag1 !== "" ? < h4 id="productTag1">{props.item.ProductTag1}</h4> : null}
                <div id="four-lines-div" style={render_color}>
                    <strong>
                        {points[0]}<hr />
                        {points[1]}<hr />
                        {points[2]}<hr />
                        {points[3]}
                    </strong>
                </div>
                <div id="highlightdetails">
                    {props.item.HighlightDetails}
                </div>
                <QuoteRequestForm source={window.location} />
                <BrochureBtn brochure={props.item.BrochureLink} />

            </div>
            <div className={divSpecCol2}>
                <p>Click image to enlarge</p>
                <a data-fancybox="gallery" href={paths.pictures + props.item.PictureLink} ><img id="canon-product-thumb-image" src={paths.pictures + props.item.ThumbLink}></img></a>
            </div>
        </div>
    )
}

export default PDHeader;

